export const add = {
  name: "add" as const,
  svg: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"><path fill-rule="evenodd" d="M11.9 3.8a8.1 8.1 0 1 0 0 16.2 8.1 8.1 0 0 0 0-16.2ZM2 11.9C2 6.432 6.432 2 11.9 2s9.9 4.432 9.9 9.9-4.432 9.9-9.9 9.9S2 17.368 2 11.9Zm9.9-4.95a.9.9 0 0 1 .9.9V11h3.15a.9.9 0 1 1 0 1.8H12.8v3.15a.9.9 0 1 1-1.8 0V12.8H7.85a.9.9 0 1 1 0-1.8H11V7.85a.9.9 0 0 1 .9-.9Z" clip-rule="evenodd"/></svg>`,
  keywords: ["add"],
  category: "other" as const,
};
